<template>
	<model-viewer
		:src="$store.state.activeModel"
		environment-image="neutral"
		camera-orbit="131.5deg 65.77deg auto"
		min-camera-orbit="auto auto 80%"
		max-camera-orbit="auto 95deg 65%"
		animation-crossfade-duration="500"
		animation-control-mode="manual"
		interaction-prompt-style="basic"
		:interaction-prompt="modelPrompt"
		camera-controls
		:class="{ 'hotspots-visible': activePrimaryNavigation === 'keyFeatures' && activeSecondaryNavigation }"
		@progress="updateProgress"
		@load="onModelLoad"
		@camera-change="onCameraChange"
		v-html="$store.state.productConfig.hotspots"
	/>

  <!-- camera-orbit="-50deg 75deg 65%" -->

	<!-- <div
		v-if="$store.state.debug"
		class="debug-info"
	>
		Orbit: {{ cameraOrbit }}<br>
		Target: {{ cameraTarget }}
	</div> -->
</template>

<script>
import { mapState } from 'vuex'
import 'model-viewer'
import { resourceUsage } from 'process'
// import '/Users/Roman/Work/Brainz/repos/model-viewer/dist/model-viewer.js'

export default {
	name: 'ModelView',
	props: {
		playing: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			modelPrompt: 'auto',
			modelPlaying: false,
			modelTime: 0,
			modelViewer: null,
			modelActions: {},
			hotspots: [],
			animationsInProgress: 0,

			cameraOrbit: '',
			cameraTarget: ''
		}
	},
	computed: mapState({
		activePrimaryNavigation: state => state.navigation.activePrimary,
		activeSecondaryNavigation: state => state.navigation.activeSecondary,
		activeSubExplanation: state => state.explanationPaneSub,
		explanationPaneOpen: state => state.explanationPaneOpen,
		animationsList: state => state.productConfig.animations,
		modelLoadingProgress: state => state.modelLoadingProgress,
		productConfig: state => state.productConfig,
    transferModeOn: state => state.navigation.transferModeOn,
    siderailsCheck: state => state.navigation.siderailsCheck
	}),
	mounted() { 
		this.$bus.on('requestModelAnimation', ({ name, direction, binary }) => {
			if(this.$store.state.activeProduct !=='ave2') return
			const binaryAnimationActive = binary && this.modelActions[name]?.time > 0

      // drive
      if (name === 'siderails') {
        if (this.animationsInProgress > 0) return
        this.handleSiderails()
        return
      }
      // rectable_steel_tray
      if (name === 'rectable_steel_tray') {
        if (this.animationsInProgress > 0) return
        this.handleSteelTray()
        return
      }
			// foot_section_tilting
      // if (name === 'foot_section_tilting') {
      //   if (this.animationsInProgress > 0) return
			// 	const trendelenburgTiming = this.modelActions['trendelenburg']?.time > 0
			// 	const fsmdTiming = this.modelActions['foot_section_movement_down_from_trendelenburg']?.time > 0

			// 	if (trendelenburgTiming && fsmdTiming) {
			// 		this.handleFootSectionTilting()
			// 	} else {
			// 		this.handleAnimationRequest(name, binaryAnimationActive || direction === 'down')
			// 	}
      //   return
      // }
			// foot_section_movement
      if (name === 'foot_section_movement_down') {
        if (this.animationsInProgress > 0) return
				const trendelenburgTiming = this.modelActions['trendelenburg']?.time > 0

				if (trendelenburgTiming) {
					this.handleFootSectionMovement()
				} else {
					this.handleAnimationRequest(name, binaryAnimationActive || direction === 'down')
				}
        return
      }
			// foot_section_retraction
      if (name === 'foot_section_retraction') {
        if (this.animationsInProgress > 0) return
				const fsmdTiming = this.modelActions['foot_section_movement_down']?.time > 0
				const fsr2Timing = this.modelActions['foot_section_retraction2']?.time > 0

				if (fsmdTiming) {
					this.handleAnimationRequest('foot_section_retraction2', fsr2Timing)
				} else {
					this.handleAnimationRequest(name, binaryAnimationActive || direction === 'down')
				}
        return
      }
			// bed up instead when trendelenburg is active
			if (name === 'horizontal_bed_movement_up' && this.modelActions['trendelenburg']?.time > 0) {
        this.handleAnimationRequest('trendelenburg', true)
        return
      }
			if (name === 'horizontal_bed_movement_up' && this.modelActions['trendelenburg_from_min']?.time > 0) {
				if (this.animationsInProgress > 0) return 
				this.handleTrendelenburg(binaryAnimationActive || direction === 'down')
        return
      }

			// backrest
      if (name === 'backrest_movement_up' || name === 'backrest_movement_up_rev') {
        if (this.animationsInProgress > 0) return
        this.handleBackrestMovement(name)
        return
      }

			// trendelenburg
      if (name === 'trendelenburg') {
        if (this.animationsInProgress > 0) return 
				this.handleTrendelenburg(binaryAnimationActive || direction === 'down')
        return
      }

			this.handleAnimationRequest(name, binaryAnimationActive || direction === 'down')
		})

		this.$bus.on('requestModelAnimationsReset', () => {
			if(this.$store.state.activeProduct !=='ave2') return
			this.resetAnimations(Object.keys(this.animationsList))
		})

		this.$bus.on('requestModelPartsVisibility', nodes => {
			if(this.$store.state.activeProduct !=='ave2') return
			nodes.forEach(node => {this.setModelNodeVisibility(node.name, node.visible)})
		})

		this.$bus.on('requestCameraPosition', cameraPosition => {
			if(this.$store.state.activeProduct !=='ave2') return
			this.setCameraPosition(cameraPosition)
		})

		this.$bus.on('requestColorChange', color => {
			if(this.$store.state.activeProduct !=='ave2') return
			localStorage.setItem('aveColor', color)
			this.setModelColor(this.productConfig.colors[color])
			this.productConfig.secondaryMenu.modifications[0].options.items[0].modelParts.forEach(node => {this.setModelNodeVisibility(node.name, node.visible)})
		})

		this.$bus.on('requestMattressChange', mattress => {
			if(this.$store.state.activeProduct !=='ave2') return
			if (mattress === 'modifications.mattress.duocoat') {
				this.setModelColor(this.productConfig.colors['duocoat'])
			} else {
				this.setModelColor(this.productConfig.colors[localStorage.getItem('aveColor') || 'pink'])
			}
		})

		window.modelVM = this // TODO: for debugging only, remove when going into production
	},
	methods: {
		onModelLoad(e) {
			const viewer = e.target
			const actions = {}

			// add all available animations to mixer and set reference for easy access
			for (const [name, animation] of Object.entries(this.animationsList)) {
				const animationTrack = viewer.scene.animationsByName.get(animation.track)

				if (animationTrack) {
					const action = viewer.animationMixer.clipAction(animationTrack)

					action.setLoop(viewer.availableLoopModes.once)
					action.clampWhenFinished = true

					actions[name] = action
				}
			}

			// set up hotspots (positioning is done by modelviewer)
			viewer.querySelectorAll('button').forEach(hotspot => {
				hotspot.setAttribute('disabled', '')
				hotspot.addEventListener('click', () => this.onHotspotClick(hotspot))
				this.hotspots.push(hotspot)
			})

			this.modelActions = actions
			this.modelViewer = viewer
			window.modelViewer = viewer
      window.modelActions = actions

			// hide duocoat parts
			const node = this.modelViewer.model.primitives.find(item => item.name === "seatDuo_geoPIV")
			node.setMeshVisibility(false)
			const node2 = this.modelViewer.model.primitives.find(item => item.name === "duocoat_geoPIV")
			node2.setMeshVisibility(false)
			const node3 = this.modelViewer.model.primitives.find(item => item.name === "legsDuo_geoPIV")
			node3.setMeshVisibility(false)
			// potisk logo
			const node4 = this.modelViewer.model.primitives.find(item => item.name === "potiskDuoCoat_geoPIV")
			node4.setMeshVisibility(false)
		},

		async handleFootSectionTilting () {
			const reverseTiming = this.modelActions['trendelenburg_foot_section_retraction_tilting']?.time > 0

			if (reverseTiming) {
				this.modelActions['foot_section_movement_down_from_trendelenburg'].setEffectiveWeight(0)
				this.playAnimation('foot_section_movement_down_from_trendelenburg', true, 100)

				this.modelActions['foot_section_movement_down_from_trendelenburg_rev'].setEffectiveWeight(1)
				await this.playAnimation('foot_section_movement_down_from_trendelenburg_rev', false)

				this.resetModel()
			} else {
				this.modelActions['trendelenburg_foot_section_retraction_tilting_rev'].setEffectiveWeight(0)
				this.playAnimation('trendelenburg_foot_section_retraction_tilting_rev', true, 100)

				this.modelActions['trendelenburg_foot_section_retraction_tilting'].setEffectiveWeight(1)
				await this.playAnimation('trendelenburg_foot_section_retraction_tilting', false)
			}
		},

		async handleFootSectionMovement () {

			const reverseTiming = this.modelActions['foot_section_movement_down_from_trendelenburg']?.time > 0

			if (reverseTiming) {
				this.modelActions['foot_section_movement_down_from_trendelenburg'].setEffectiveWeight(0)
				this.playAnimation('foot_section_movement_down_from_trendelenburg', true, 100)

				this.modelActions['foot_section_movement_down_from_trendelenburg_rev'].setEffectiveWeight(1)
				await this.playAnimation('foot_section_movement_down_from_trendelenburg_rev', false)

				this.resetModel()
			} else {
				this.modelActions['foot_section_movement_down_from_trendelenburg_rev'].setEffectiveWeight(0)
				this.playAnimation('foot_section_movement_down_from_trendelenburg_rev', true, 100)

				this.modelActions['foot_section_movement_down_from_trendelenburg'].setEffectiveWeight(1)
				await this.playAnimation('foot_section_movement_down_from_trendelenburg', false)
			}
		},

		async handleTrendelenburg(reverse) {
			const br1Timing = this.modelActions['backrest_movement_up']?.time > 0
			const br2Timing = this.modelActions['backrest_movement_up2']?.time > 0
			const hbmdTiming = this.modelActions['horizontal_bed_movement_down']?.time > 0
			const tfmTiming = this.modelActions['trendelenburg_from_min']?.time > 0

			if (this.modelActions['foot_section_movement_down_from_trendelenburg']?.time > 0 || this.modelActions['foot_section_movement_down']?.time > 0) {
				return
			}

			if (br2Timing || br1Timing) {
				if (br2Timing) {
					this.modelActions['backrest_movement_up2'].setEffectiveWeight(0)
					this.playAnimation('backrest_movement_up2', true, 100)

					this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(1)
					await this.playAnimation('backrest_movement_up_rev', false)
				}

				this.modelActions['backrest_movement_up'].setEffectiveWeight(0)
				this.playAnimation('backrest_movement_up', true, 100)
				this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(0)
				this.playAnimation('backrest_movement_up_rev', true, 100)

				this.modelActions['backrest_movement_up_rev2'].setEffectiveWeight(1)
				await this.playAnimation('backrest_movement_up_rev2', false)
			}

			if(hbmdTiming) {
				this.modelActions[tfmTiming ? 'trendelenburg_from_min' : 'trendelenburg_to_min'].setEffectiveWeight(0)
				this.playAnimation(tfmTiming ? 'trendelenburg_from_min' : 'trendelenburg_to_min', true, 100)

				this.modelActions[tfmTiming ? 'trendelenburg_to_min' : 'trendelenburg_from_min'].setEffectiveWeight(1)
				await this.playAnimation(tfmTiming ? 'trendelenburg_to_min' : 'trendelenburg_from_min', false)

				if (tfmTiming) this.resetModel()
			} else {
				this.modelActions[reverse ? 'trendelenburg' : 'trendelenburg_rev'].setEffectiveWeight(0)
				this.playAnimation(reverse ? 'trendelenburg' : 'trendelenburg_rev', true, 100)

				this.modelActions[reverse ? 'trendelenburg_rev' : 'trendelenburg'].setEffectiveWeight(1)
				await this.playAnimation(reverse ? 'trendelenburg_rev' : 'trendelenburg', false)

				if (reverse) this.resetModel()
			}

			
		},

		async handleBackrestMovement(name) {
			const br1Timing = this.modelActions['backrest_movement_up']?.time > 0
      const br2Timing = this.modelActions['backrest_movement_up2']?.time > 0
			const downTiming = this.modelActions['backrest_movement_down']?.time > 0

			if (name === 'backrest_movement_up') {
				if (br2Timing) {
					return
				} else if (br1Timing) {
					this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up_rev', true, 100)
					this.modelActions['backrest_movement_up'].setEffectiveWeight(0)

					this.modelActions['backrest_movement_up2'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_up2', false)
				} else if (downTiming) {
					this.modelActions['backrest_movement_down'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_down', true, 100)

					this.modelActions['backrest_movement_down_rev'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_down_rev', false)
				} else {
					this.modelActions['backrest_movement_down_rev'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_down_rev', true, 100)
					this.modelActions['backrest_movement_up_rev2'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up_rev2', true, 100)

          this.modelActions['backrest_movement_up'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_up', false)
				}
			} else {
				if (br2Timing) {
          this.modelActions['backrest_movement_up2'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up2', true, 100)

					this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_up_rev', false)
				} else if (br1Timing) {
					this.modelActions['backrest_movement_up'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up', true, 100)
					this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up_rev', true, 100)

					this.modelActions['backrest_movement_up_rev2'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_up_rev2', false)
				} else {
					this.modelActions['backrest_movement_up_rev2'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_up_rev2', true, 100)
					this.modelActions['backrest_movement_down_rev'].setEffectiveWeight(0)
          this.playAnimation('backrest_movement_down_rev', true, 100)

					this.modelActions['backrest_movement_down'].setEffectiveWeight(1)
          await this.playAnimation('backrest_movement_down', false)
				}
			}
		},

    async handleSiderails() {
      const siderailsTiming = this.modelActions['siderails_rotation']?.time > 0

      if (siderailsTiming) {
        this.modelActions['siderails_rotation'].setEffectiveWeight(0)
        this.playAnimation('siderails_rotation', true, 100)

        this.modelActions['siderails_rotation_rev'].setEffectiveWeight(1)
        await this.playAnimation('siderails_rotation_rev', false)
      } else {
        this.modelActions['siderails_rotation_rev'].setEffectiveWeight(0)
        this.playAnimation('siderails_rotation_rev', true, 100)

        this.modelActions['siderails_rotation'].setEffectiveWeight(1)
        await this.playAnimation('siderails_rotation', false)
      }
    },

    async handleSteelTray() {
			const fsmdTiming = this.modelActions['foot_section_movement_down']?.time > 0

			let steelAnimation = 'stainless_steel_tray'
			let steelAnimationRev = 'stainless_steel_tray_rev'
			let steelTrayTiming = this.modelActions['stainless_steel_tray']?.time > 0

			if (fsmdTiming) {
				steelAnimation = 'stainless_steel_tray_only'
				steelAnimationRev = 'stainless_steel_tray_only_rev'
				steelTrayTiming = this.modelActions['stainless_steel_tray_only']?.time > 0
			}

      if (steelTrayTiming) {
        this.modelActions[steelAnimation].setEffectiveWeight(0)
        this.playAnimation(steelAnimation, true, 100)

        this.modelActions[steelAnimationRev].setEffectiveWeight(1)
        await this.playAnimation(steelAnimationRev, false)
      } else {
        this.modelActions[steelAnimationRev].setEffectiveWeight(0)
        this.playAnimation(steelAnimationRev, true, 100)

        this.modelActions[steelAnimation].setEffectiveWeight(1)
        await this.playAnimation(steelAnimation, false)
      }
    },

    async handleAnimationRequest(animationName, reverse) {
			this.hideInteractionPrompt()
      if (this.animationsInProgress > 0) return
      let animationConfig = this.animationsList[animationName]

      if (animationConfig.blocking) {
        if (animationConfig.blocking.find(animation => this.modelActions[animation]?.time > 0)) {
          return
        }
      }
      if (animationConfig.required) {
        if (this.modelActions[animationConfig.required]?.time === 0) {
          return
        }
      }

      if (reverse) {
        this.modelActions[animationConfig.track].setEffectiveWeight(0)
        this.playAnimation(animationConfig.track, true, 100)

			  this.modelActions[animationConfig.opposite].setEffectiveWeight(1)
        await this.playAnimation(animationConfig.opposite, false)

        this.resetModel()
      } else {
        this.modelActions[animationConfig.opposite].setEffectiveWeight(0)
        this.playAnimation(animationConfig.opposite, true, 100)

			  this.modelActions[animationConfig.track].setEffectiveWeight(1)
        await this.playAnimation(animationConfig.track, false)

        if (animationConfig.reset) this.resetModel()
      }
		},

    async resetModel() {
      this.modelActions['backrest_movement_up_rev'].setEffectiveWeight(0)
			this.modelActions['backrest_movement_down_rev'].setEffectiveWeight(0)
      this.modelActions['foot_section_movement_up'].setEffectiveWeight(0)
			this.modelActions['foot_section_movement_down_from_trendelenburg_rev'].setEffectiveWeight(0)
      this.modelActions['foot_section_retraction_rev'].setEffectiveWeight(0)
			this.modelActions['foot_section_retraction2_rev'].setEffectiveWeight(0)
      this.modelActions['foot_section_tilting_rev'].setEffectiveWeight(0)
      this.modelActions['horizontal_bed_movement_up'].setEffectiveWeight(0)
      this.modelActions['horizontal_leg_rest_movement_rev'].setEffectiveWeight(0)
      this.modelActions['horizontal_leg_rest_tray_movement_rev'].setEffectiveWeight(0)
      this.modelActions['horizontal_leg_rest_tray_tilting_rev'].setEffectiveWeight(0)
      this.modelActions['trendelenburg_rev'].setEffectiveWeight(0)
			this.modelActions['trendelenburg_from_min'].setEffectiveWeight(0)
			this.modelActions['trendelenburg_to_min'].setEffectiveWeight(0)
      this.modelActions['seat_section_adjustment_rev'].setEffectiveWeight(0)
      this.modelActions['siderails_rotation_rev'].setEffectiveWeight(0)
      this.modelActions['stainless_steel_tray_rev'].setEffectiveWeight(0)
			this.modelActions['stainless_steel_tray_only_rev'].setEffectiveWeight(0)
      this.modelActions['vertical_leg_rest_movement_rev'].setEffectiveWeight(0)
      this.modelActions['vertical_leg_rest_tray_movement_rev'].setEffectiveWeight(0)

      this.playAnimation('backrest_movement_up_rev', true, 100)
			this.playAnimation('backrest_movement_down_rev', true, 100)
      this.playAnimation('foot_section_movement_up', true, 100)
			this.playAnimation('foot_section_movement_down_from_trendelenburg_rev', true, 100)
      this.playAnimation('foot_section_retraction_rev', true, 100)
			this.playAnimation('foot_section_retraction2_rev', true, 100)
      this.playAnimation('foot_section_tilting_rev', true, 100)
      this.playAnimation('horizontal_bed_movement_up', true, 100)
      this.playAnimation('horizontal_leg_rest_movement_rev', true, 100)
      this.playAnimation('horizontal_leg_rest_tray_movement_rev', true, 100)
      this.playAnimation('horizontal_leg_rest_tray_tilting_rev', true, 100)
      this.playAnimation('trendelenburg_rev', true, 100)
			this.playAnimation('trendelenburg_from_min', true, 100)
			this.playAnimation('trendelenburg_to_min', true, 100)
      this.playAnimation('seat_section_adjustment_rev', true, 100)
      this.playAnimation('siderails_rotation_rev', true, 100)
      this.playAnimation('stainless_steel_tray_rev', true, 100)
			this.playAnimation('stainless_steel_tray_only_rev', true, 100)
      this.playAnimation('vertical_leg_rest_movement_rev', true, 100)
      await this.playAnimation('vertical_leg_rest_tray_movement_rev', true, 100)
    },

		playAnimation(name, reverse, speed = 1) {
			return new Promise(resolve => {
				console.log(`${reverse ? 'Reversing' : 'Playing'} animation:`, name)
				const action = this.modelActions[name]
				const timeScaleSign = reverse ? -1 : 1

				// start the rendering loop
				this.modelViewer.play()

				action.setEffectiveTimeScale(speed * timeScaleSign)
				action.enabled = true
				action.paused = false
				action.play()

				this.animationsInProgress = this.animationsInProgress + 1

				// set up listener when animation finishes
				// assigning the callback to action.finishedCallback makes the listener unique so that it can be removed afterwards
				this.modelViewer.animationMixer.addEventListener('finished', action.finishedCallback = e => {
					const finishedTrackName = e.action.getClip().name

					if (finishedTrackName === this.animationsList[name].track) {
						this.modelViewer.animationMixer.removeEventListener('finished', action.finishedCallback)

						// save resources by pausing the rendering loop when no animations are playing
						if (this.animationsInProgress === 1) {
							this.modelViewer.pause()
						}
						this.animationsInProgress = this.animationsInProgress - 1

						action.enabled = !reverse

						resolve()
					}
				})
			})
		},

		resetAnimations(animationNames = [], speed = 1) {
			const animationsPromises = []

			animationNames.forEach(animationName => {
				if (this.modelActions[animationName]?.time > 0) {
					animationsPromises.push(this.playAnimation(animationName, true, speed))
				}
			})

			return Promise.all(animationsPromises)
		},

		setModelNodeVisibility(nodeName, visible) {
			const node = this.modelViewer.model.primitives.find(item => item.name === nodeName)
			node.setMeshVisibility(visible)
		},

		setModelColor(color) {
			this.modelViewer.model.materials.find(item => item.name === 'GLSLShader1kuze').pbrMetallicRoughness.setBaseColorFactor(color)
		},

		updateProgress(e) {
			this.$store.commit('setModelLoadingProgress', e.detail.totalProgress)
		},

		hideInteractionPrompt() {
			this.modelPrompt = 'none'
		},

		setCameraPosition(position) {
			this.modelViewer.cameraOrbit = position.orbit
			this.modelViewer.cameraTarget = position.target
		},

		resetCameraPosition() {
			this.setCameraPosition({
				orbit: '-50deg 75deg 65%',
				target: 'auto auto auto'
			})
		},

		onHotspotClick(hotspot) {
			const explanations = hotspot.dataset.explanations?.split('.')
			if (explanations) {
				const explanation = explanations[0]
				const subExplanation = explanations[1] || null
        const explanationItem = this.productConfig.explanations[explanation]
        const subExplanationItem = this.productConfig.explanations[subExplanation]
				this.$store.commit('navigation/setActiveSecondary', 'key_features.' + explanation)
				this.$store.commit('setExplanationPaneContent', explanationItem)
				this.$store.commit('setExplanationPaneSub', subExplanation)
				this.$store.commit('setExplanationPaneOpen', true)

        if (subExplanationItem?.camera) {
          this.setCameraPosition(subExplanationItem.camera)
        }
			}
		},

		onCameraChange() {
			this.cameraOrbit = this.modelViewer?.getCameraOrbit() || ''
			this.cameraTarget = this.modelViewer?.getCameraTarget() || ''
		}
	},
  watch: {
		activeSecondaryNavigation(val) {
			if (this.activePrimaryNavigation === 'keyFeatures') {
				// disable hotspots not related to active feature
				this.hotspots.forEach(hotspot => {
					const navItemName = val.split('.')[1]
					const hotspotExplanations = hotspot.dataset.explanations?.split('.')
					hotspot.classList.remove('active')
					if (hotspotExplanations[0] === navItemName) {
						if (hotspotExplanations.length === 1) {
							hotspot.classList.add('active')
						}
						hotspot.removeAttribute('disabled')
					} else {
						hotspot.setAttribute('disabled', '')
					}
				})
			}
		},
		activeSubExplanation(name) {
			if (this.activePrimaryNavigation === 'keyFeatures') {
				// display hotspot as active when related feature + subExplanation is selected
				this.hotspots.forEach(hotspot => {
					const hotspotExplanation = hotspot.dataset.explanations?.split('.')[1]
					if (hotspotExplanation === name) {
						hotspot.classList.add('active')
					} else {
						hotspot.classList.remove('active')
					}
				})
			}
		},
		explanationPaneOpen(open) {
			if (!open) {
				this.$nextTick(() => {
					this.resetCameraPosition()
				})
			}
		}
	},
}
</script>

<style lang="scss" scoped>
model-viewer {
	width: 100%;
	height: 100%;
	--poster-color: transparent;
	--min-hotspot-opacity: 0;

	&::part(default-progress-bar) {
		top: 30px;
		background-color: $clrRed;
	}
}

::v-deep(.Hotspot) {
	display: none;
	position: relative;
	width: 26px;
	height: 26px;
	background-color: transparentize($color: $clrWhite, $amount: 0.2);
	border-radius: 100px;
	box-shadow: 0 0 0 4px transparentize($color: $clrWhite, $amount: 0.5);
	transition: all 300ms ease 200ms;
	&.active,
	&:hover,
	&:disabled,
	&:not([data-visible]) {
		background-color: transparent;
		box-shadow: 0 0 0 0 transparent;
		transition: all 300ms ease;
	}
	&:disabled {
		pointer-events: none;
	}
	.hotspots-visible & {
		display: block;
	}

	&::before {
		content: "";
		position: absolute;
		width: 17px;
		height: 17px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 100px;
		border: 1px solid $clrWhite;
		background-color: $clrRed;
		background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M128 29.799v196.403M226.202 128H29.799' stroke-linecap='round' stroke-miterlimit='10' stroke-width='51.7px' fill='none' stroke='%23FFFFFF'/%3E%3C/svg%3E%0A");
		background-size: 10px;
		background-repeat: no-repeat;
		background-position: center;
		transition: all 300ms ease 200ms;
	}
	&.active::before,
	&:hover::before,
	&:disabled::before,
	&:not([data-visible])::before {
		transform: translate(-50%, -50%) scale(0.6);
		opacity: 0;
		transition: all 300ms ease;
	}

	.HotspotAnnotation {
		position: absolute;
		left: 50%;
		bottom: 24px;
		padding: 0.2em 0.75em;
		transform: translate(-50%, 30%);
		opacity: 0;
		font-size: 12px;
		font-weight: 500;
		white-space: nowrap;
		border-radius: 100px;
		background-color: $clrWhite;
		transition: all 300ms ease;
		pointer-events: none;
		z-index: 100;

		&::before {
			content: "";
			position: absolute;
			width: 0;
			height: 0;
			bottom: -6px;
			left: calc(50% - 6px);
			border-style: solid;
			border-width: 6px 6px 0 6px;
			border-color: #ffffff transparent transparent transparent;
		}
	}
	&:hover, &.active {
		.HotspotAnnotation {
			opacity: 1;
			transform: translate(-50%, 0);
			pointer-events: all;
			color: $clrRed;
		}
	}
}

.debug-info {
	position: absolute;
	top: 50px;
	left: 300px;
	font-size: 10px;
}
</style>
